import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
  UserRoleType,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import { UnverifiedUserListColumns } from "../../appconfig/DatatableSetting";
import { getAllDetails, getDetails, getSpecificDetails, postAllData, postDataByID } from "../../service/ProductService";
import { EDIT_UNVERIFIED_USER, GET_UNVERIFIED_USER_LIST, SEND_VERIFY_EMAIL } from "../../config/ApiConstant";
import { Dialog } from "primereact/dialog";
import { validateUnverifiedUserField } from "../../config/Validate";
import { Dropdown } from "primereact/dropdown";
import { addressTemplate, nameCompanyTemplate, nameTemplate } from "../../appconfig/TemplateFieldSetting";
import { Card } from "primereact/card";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { globalNameFilterTemplate } from "../../appconfig/AppHelper";

const UnverifiedUsers = () => {
  document.title = "Unverified Users | Nexawage Payroll";
  const toast = useRef<any>(null);

  // filter
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // error state
  const [errors, setErrors] = useState<any>({});

  // Unverified user Details
  const [unverifiedUserDetails, setUnverifiedUserDetails] = useState<any>(null);

  // global user data
  const [globleUserData, setGlobalUserData] = useState<any>({});

  // isedit true false
  const [isEdit, setIsEdit] = useState<boolean>(false);

  //   page load
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  //   submit loading
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  //   edit email dialog
  const [editEmailDialog, setEditEmailDialog] = useState<boolean>(false);

  // send Email dialog
  const [emailSendDialog, setEmailSendDialog] = useState<boolean>(false);
  const [selectedRowId, setSelectedRowId] = useState<any>(null);

  //   select role
  const [selectedRole, setSelectedRole] = useState<any>("3");

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },

    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  //   useEffect
  useEffect(() => {
    getUnverifiedUserList();
  }, [selectedRole]);

  //   get unverified user list
  const getUnverifiedUserList = async () => {
    try {
      setPageLoad(false);
      const response = await getAllDetails(`${GET_UNVERIFIED_USER_LIST}?role_id=${selectedRole}`);

      let data = response;

      //Check Id Base Response Set
      if (data) {
        setUnverifiedUserDetails(data);
        setPageLoad(true);
      } else {
        setUnverifiedUserDetails([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  //   on input change
  const onInputChange = (e: any, name: string) => {
    let val = e?.target?.value ?? e?.value;

    setGlobalUserData({ ...globleUserData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  //   submit email edit form
  const submitUserForm = async () => {
    const { isError, errors } = validateUnverifiedUserField(globleUserData);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);
    try {
      const payload = {
        id: globleUserData?.id,
        email: globleUserData?.email,
      };

      const response = await postAllData(EDIT_UNVERIFIED_USER, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideEmailEditDialog();
        getUnverifiedUserList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  //   send email api call
  const sendEmail = async () => {
    try {
      setSubmitLoading(true);
      const response = await getDetails(`${SEND_VERIFY_EMAIL}/${selectedRowId}`);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideEmailDialog();
        getUnverifiedUserList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
    setSelectedRole("3");
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span>
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div>
        <label className="mr-2" style={{ fontWeight: "bold" }}>
          Select Role :
        </label>
        <Dropdown
          value={selectedRole || ""}
          onChange={(e) => setSelectedRole(e.value)}
          options={UserRoleType}
          placeholder="Select User Role"
          className="mr-3 w-12rem"
        />
      </div>

      <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="mr-2 p-button-outlined common-p-outline-button" />
    </>
  );

  // add and edit user modal
  const addEditDialog = (rowData: any = null) => {
    if (rowData) {
      setGlobalUserData({ ...rowData });
      setIsEdit(true);
    } else {
      setGlobalUserData({});
      setIsEdit(false);
    }
    setErrors({});
    setEditEmailDialog(true);
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-pencil"
        tooltip="Edit Email"
        className="common-edit-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => addEditDialog(rowData)}
      />
      <Button
        tooltip={"Resend Email"}
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 common-primary-button"
        icon="pi pi-envelope"
        label=""
        onClick={() => confirmantionEmailDialog(rowData.id)}
      />
    </div>
  );

  //   hide edit email dialog
  const hideEmailEditDialog = () => {
    setEditEmailDialog(false);
    setSubmitLoading(false);
  };

  // hide send email modal
  const hideEmailDialog = () => {
    setEmailSendDialog(false);
    setSubmitLoading(false);
  };

  // open dialogdialog
  const confirmantionEmailDialog = async (payeeId: any) => {
    setEmailSendDialog(true);
    setSelectedRowId(payeeId);
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu={`${selectedRole == "3" ? "Client" : selectedRole == "2" ? "Employee" : "User"}`}
        pageName="List"
        pageTitle={`Unverified User / Client`}
      />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />

            {pageLoad ? (
              <DataTable
                value={unverifiedUserDetails}
                showGridlines
                dataKey="id"
                responsiveLayout={"scroll"}
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={unverifiedUserDetails?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Unverified Users"}
                emptyMessage="No Data Found"
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                removableSort
              >
                {UnverifiedUserListColumns.map((col: any, i: any) => {
                  if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} body={nameCompanyTemplate} />;
                  } else if (col.field === "email") {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterElement={globalNameFilterTemplate} />;
                  } else if (col.field === "address") {
                    return <Column key={col.field} field={col.field} header={col.header} body={addressTemplate} />;
                  } else if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "phone") {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {UnverifiedUserListColumns.map((col: any) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* edit email dialog */}
      <Dialog
        visible={editEmailDialog}
        className="mx-3 lg:mx-0"
        style={{ width: "450px" }}
        header={"Edit & Send Mail"}
        draggable={false}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideEmailEditDialog} />
            <Button label="Update" icon="pi pi-check" onClick={submitUserForm} className="common-primary-button" loading={submitLoading} />
          </div>
        }
        onHide={hideEmailEditDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Email */}
          <div className="field col-12 md:col-10">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={globleUserData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
        </div>
      </Dialog>

      {/* Email Send Dialog */}
      <Dialog
        visible={emailSendDialog}
        style={{ width: "450px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Confirmation To send Email"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" disabled={submitLoading} onClick={hideEmailDialog} />
            <Button label="Send Email" icon="pi pi-check" className="common-primary-button" onClick={sendEmail} loading={submitLoading} />
          </div>
        }
        onHide={hideEmailDialog}
      >
        <h5>Are you sure you want to send email ? </h5>
        <div className="grid p-fluid formgrid"></div>
      </Dialog>
    </>
  );
};

export default UnverifiedUsers;
